export default function () {
}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/resources/mounted.js